import {
  CONSULTATION_CREATION,
  UPLOAD_START,
  UPLOAD_PROGRESS,
  UPLOAD_END,
} from './constants';

export function consultationCreation({ data, isDraft, redirectUrl, submitUrl, workflowId }) {
  return {
    type: CONSULTATION_CREATION,
    payload: {
      data,
      isDraft,
      redirectUrl,
      submitUrl,
      workflowId,
    },
  };
}

export function uploadStart({ id }) {
  return {
    type: UPLOAD_START,
    payload: {
      id,
    },
  };
}

export function uploadProgress({ id, progress, secondsRemaining }) {
  return {
    type: UPLOAD_PROGRESS,
    payload: {
      id,
      progress,
      secondsRemaining,
    },
  };
}

export function uploadEnd({ id }) {
  return {
    type: UPLOAD_END,
    payload: {
      id,
    },
  };
}
